import React from 'react';

export const getStatusConfig = (status) => {
    const s = status?.toUpperCase() || 'PENDING';
    const map = {
        PENDING: { bg: "#f1f5f9", color: "#64748b" },
        PROCESSING: { bg: "#fef3c7", color: "#f59e0b" },
        DISPATCHED: { bg: "#e0f2fe", color: "#0ea5e9" },
        OUT_FOR_DELIVERY: { bg: "#ede9fe", color: "#8b5cf6" },
        DELIVERED: { bg: "#d1fae5", color: "#10b981" },
        FAILED: { bg: "#fee2e2", color: "#ef4444" },
        RETURNED: { bg: "#ffedd5", color: "#f97316" },
        CANCELLED: { bg: "#ffe4e6", color: "#e11d48" }
    };
    return map[s] || { bg: "#f1f5f9", color: "#64748b" };
};

export default function ShipmentStatusBadge({ status, style = {} }) {
    const config = getStatusConfig(status);

    return (
        <span
            className="rounded-pill px-3 py-1 fw-bold text-uppercase d-inline-block text-center"
            style={{
                fontSize: "11px",
                background: config.bg,
                color: config.color,
                letterSpacing: "0.5px",
                ...style
            }}
        >
            {status?.replace(/_/g, ' ') || 'Unknown'}
        </span>
    );
}
